import { LegacySportBroadcastPlayerBaseInfoContent } from '@funtech-int/kp-graphql-sdk/yango-movies-www';

import { useReadPlayerBaseInfo } from '@/scenarios/legacy-player/components/player-manager/hooks/use-read-player-base-info';

export function useReadSportPlayerBaseInfo(
    contentId: string
): LegacySportBroadcastPlayerBaseInfoContent | null {
    const data = useReadPlayerBaseInfo(contentId);

    if (data?.content?.__typename === 'SportBroadcast') {
        return data.content;
    }

    return null;
}
